var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.06756 3.14774C2.18673 2.8909 2.44414 2.72656 2.72728 2.72656H17.2727C17.5559 2.72656 17.8133 2.8909 17.9324 3.14774C18.0516 3.40459 18.0109 3.70725 17.828 3.92345L12.1818 10.6001V16.5447C12.1818 16.7968 12.0513 17.0309 11.8369 17.1634C11.6225 17.2959 11.3547 17.3079 11.1293 17.1952L8.22021 15.7407C7.97382 15.6175 7.81818 15.3657 7.81818 15.0902V10.6001L2.17196 3.92345C1.98912 3.70725 1.94839 3.40459 2.06756 3.14774ZM4.29477 4.18111L9.10078 9.86421C9.21181 9.9955 9.27273 10.1619 9.27273 10.3338V14.6407L10.7273 15.368V10.3338C10.7273 10.1619 10.7882 9.9955 10.8992 9.86421L15.7052 4.18111H4.29477Z",
    fill: "#727E8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.a0850b11c5f9d6ff2afd3b22439b9571.svg";
export { ForwardRef as ReactComponent };